/**Все настройки в одном файле */

//mode: dev для фейкового api
export let api_config=
    {mode:"dev4",
        url:"/test/",
        fake_api_timeout: 1200
    }
